import { useEffect } from "react";
import ContentsPayment from "./ContentsPayment"

import '../../Components/Styles/NudgeDialog.scss';
import NudgeDialog from "./Components/NudgeDialog";
import { useHistorys } from "../../Recoil/Purchase/History";

const Payment = ({serviceId, titleId, menu}: {serviceId: string, titleId: string, menu?: string}) => {

    const {fetch} = useHistorys();
    useEffect(()=>{
        fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    
    return (<div>
        <ContentsPayment serviceId={serviceId} titleId={titleId} />
        <NudgeDialog {...{serviceId, titleId, menu}} />
    </div>);
}

export default Payment;